<template>
  <div class="container">
    <el-button style="padding-right:4px;font-size: 18px" slot="suffix" type="text" @click="getBackEdit()">{{title}}</el-button>
    <el-table
      v-loading="loading"
      :data="tableData"
      border
      height="350"
      style="width: 100%">
      <el-table-column label="序号" type="index" width="50" />
      <el-table-column prop="projectName" label="历史项目名称" align="center" />
      <el-table-column prop="createUserName" label="修改人" align="center" />
      <el-table-column prop="createTime" label="修改时间" align="center" />
    </el-table>
  </div>
</template>

<script>
import {getListHistoryProject} from "@/api/dataMana";

export default {
  name:"historyProject",
  props:["historyProjectDetail"],
  data(){
    return{
      title:'<返回项目编辑',
      tableData:[],
      loading: false,
    }
  },
  created() {

  },
  mounted() {
    this.getListHistory(this.historyProjectDetail.id)
  },
  methods:{
     async getListHistory(id){
       this.loading = true
       await getListHistoryProject(id).then(res=>{
         if (res.code === "200") {
           this.tableData = res.data;
           console.log(res.data)
         } else {
           this.$message.error(res.msg || "服务器连接失败");
         }
         this.loading = false;
       }).catch((err) => {
           this.loading = false;
           this.$message.error(err.msg || err.message || "服务器连接失败");
         });
    },
    getBackEdit(){
      this.$emit("getBackEdit",this.historyProjectDetail)
    }
  }
}
</script>

<style lang="less" scoped>

.container {
  .container_hs{
    color: #0E77D1;
    font-size: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Datamanagement/components/historyProject.vue